<script>
  //Importing Bar class from the vue-chartjs wrapper
  import { Pie } from 'vue-chartjs'
  //Exporting this so it can be used in other components
  export default {
    extends: Pie,
    props: ['datachart'],
    data () {
      return {
        options: {
          scales: {
            yAxes: [{
                ticks: {
                   display: false
                },
              gridLines: {
                display: false
              }
            }],
            xAxes: [ {
              gridLines: {
                display: false
                },
                ticks: {
                    display: false
                }
            }]
          },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    mounted () {
      //renderChart function renders the chart with the datacollection and options object.
      this.renderChart(this.datachart, this.options)
    }
  }
</script>
